var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnconfirmed = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#5D6168",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.517 17.71c0-.418-.139-.753-.416-1.006-.277-.253-.644-.379-1.101-.379-.282 0-.537.06-.766.182a1.704 1.704 0 0 0-.59.533.877.877 0 0 1-.635.386.831.831 0 0 1-.692-.211.69.69 0 0 1-.227-.467.825.825 0 0 1 .14-.525A3.262 3.262 0 0 1 20 14.75c.943 0 1.709.267 2.297.802.588.535.882 1.235.882 2.1 0 .438-.092.831-.277 1.181-.185.35-.525.764-1.02 1.24-.36.34-.604.605-.73.795-.126.19-.21.406-.248.649a1.024 1.024 0 0 1-.299.583.798.798 0 0 1-.576.233.812.812 0 0 1-.576-.226.74.74 0 0 1-.24-.561c0-.38.082-.727.247-1.043.166-.316.443-.649.832-.999.495-.437.823-.775.984-1.013.16-.239.24-.499.24-.78ZM20 25.833c-.32 0-.596-.114-.824-.342a1.124 1.124 0 0 1-.343-.824c0-.321.115-.596.343-.824.228-.229.503-.343.824-.343.32 0 .595.114.824.343.228.228.343.503.343.824 0 .32-.115.595-.343.824a1.123 1.123 0 0 1-.824.342Z"
})));
SvgUnconfirmed.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnconfirmed);
export default ForwardRef;